import { html } from 'rune-ts';
import { ButtonActionProps } from '../../ButtonAction/ButtonAction';
import { preventEscape } from '../../../../util/preventEscape';
import { BaseDateButtonAction } from './BaseDateButtonAction.ts';

export class LimitedTimeButtonAction extends BaseDateButtonAction {
  protected override makeType(): ButtonActionProps['type'] {
    return 'blue';
  }

  protected override makeLabel() {
    const [days, hours, minutes, seconds] = BaseDateButtonAction.diff(this.data.end, this.data.start);
    return html`
      <b>${this.data.label || ET('cta::limited')}</b>
      <div data-is-limited data-end="${this.data.end}" data-start="${this.data.start}">
        ${preventEscape(BaseDateButtonAction.convertLabel({ days, hours, minutes, seconds }))}
      </div>
    `;
  }
}
